export const figure23 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#bf9000', '#ffe699', '#ffc000'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: ["Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)", "Afrique subsaharienne", "Asie de l’Ouest et Afrique du Nord", "Australie et Nouvelle-Zélande", "Asie de l’Est et Asie du Sud-Est", "Amérique latine et Caraïbes", "Asie centrale et Asie du Sud", "Amérique du Nord et Europe"],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        max: 6,
        min: 0,
        tickInterval: 1,
          gridLineWidth: 2,
	  title: {
	text: 'Millions',
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2000',
        data: [1.347, 1.43323, 65.576, 1.96154, 2.14285, 2.65441, 3.51299, 16.37687],
      },
      {
        name: '2015*',
        data: [3.601, 2.01387, 1.80665, 2.55088, 3.17598, 4.35292, 54.12334, 26.70782]
      },
	{
	  name: '2021',
	  data: [4.738, 2.13494, 2.41778, 2.85200, 3.44843, 4.65618, 5.92772, 27.96969]
	      }	      
    ]
}
